import { render } from "./PlotElementsPool.vue?vue&type=template&id=2b1ac920"
import script from "./PlotElementsPool.vue?vue&type=script&lang=js"
export * from "./PlotElementsPool.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sjoshi6/git/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__